import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import ContactSupportIcon from '@material-ui/icons/ContactSupport'
import clsx from 'clsx'
import SubmitButton from 'components/common/submitButton'
import CloseButton from 'components/dialogs/closeButton'
import WebsiteCustomizationForm, {
    WebsiteCustomizationFormState,
} from 'components/forms/establishment/websiteCustomizationForm'
import React from 'react'
import { Trans } from 'react-i18next'
import { useStyles } from '../../establishment/dialogs/styles.css'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: WebsiteCustomizationFormState) => void
    inProgress: boolean
    initialValues: WebsiteCustomizationFormState
}

export const EditModal: React.FC<Props> = ({ open, onClose, inProgress, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
            maxWidth="md"
        >
            <WebsiteCustomizationForm formClassName={classes.form} inProgress={inProgress} {...formData}>
                {(content, actions, prepend) => (
                    <>
                        <DialogTitle className={classes.title}>
                            <Trans i18nKey="views.externalLinks.customization.title" />
                            <Button
                                variant="outlined"
                                className={classes.action}
                                href="https://resto.suggpro.com/page-aide-site-web"
                                target="_blank"
                                endIcon={<ContactSupportIcon />}
                            >
                                <Trans i18nKey="actions.help" />
                            </Button>
                        </DialogTitle>
                        {prepend}
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                >
                                    <Trans i18nKey="actions.validate" />
                                </SubmitButton>
                            ))}
                        </DialogActions>
                    </>
                )}
            </WebsiteCustomizationForm>
        </Dialog>
    )
}
